import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  autocomplete: "off",
  class: "flex flex-col gap-3"
}
const _hoisted_2 = { class: "grid h-full w-full grid-cols-1 gap-3" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex h-full flex-col justify-center rounded-l-lg bg-gray-50 px-2 py-4" }
const _hoisted_5 = { class: "flex flex-col items-start p-3" }
const _hoisted_6 = { class: "font-semibold text-gray-700" }
const _hoisted_7 = { class: "text-left text-xs text-gray-500" }

import { computed, ComputedRef } from 'vue';
import store from '@/store';

import {
    PlusCircleIcon,
    ClockIcon,
    PlayIcon,
    ReplyIcon,
    ExternalLinkIcon,
    PhoneMissedCallIcon,
    ReceiptRefundIcon,
    QuestionMarkCircleIcon,
    AnnotationIcon,
    AdjustmentsIcon,
} from '@heroicons/vue/outline';

import {
    ConnectFlowModelingActions,
    ConnectFlowModelingGetters,
    ConnectFlowModelingMenu,
    FlowNodeModel,
    NodeType,
    VueFlowNodeModel,
} from '@/types';

import { flowNodeRules } from '@/configs';


export default /*@__PURE__*/_defineComponent({
  __name: 'ComponentSelector',
  setup(__props) {

const menu: ComputedRef<ConnectFlowModelingMenu> = computed(
    () => store.getters['flow/' + ConnectFlowModelingGetters.MENU],
);

const connectFlowCustomOptions = computed(
    () => store.getters['flow/' + ConnectFlowModelingGetters.CONNECT_FLOW_CUSTOM_OPTIONS] || [],
);

const hasConnectFlowCustomOptions = computed(() => connectFlowCustomOptions.value.length > 0);

const showForm = computed({
    get: () => menu.value.show,
    set: (value) => store.dispatch('flow/' + ConnectFlowModelingActions.SET_MENU, value),
});

const triggerNode: ComputedRef<VueFlowNodeModel> = computed(() => {
    if (menu.value.idTriggerBy) {
        return store.getters['flow/' + ConnectFlowModelingGetters.ELEMENT_BY_ID](
            menu.value.idTriggerBy,
        );
    }
    return null;
});

const rules: ComputedRef<FlowNodeModel> = computed(
    () => flowNodeRules[triggerNode.value?.data.component],
);

function setUpNode(component: string) {
    const action = menu.value.action;

    switch (action) {
        case 'add':
            store.dispatch('flow/' + ConnectFlowModelingActions.PUSH_NEW_NODE, {
                data: { component },
            });
            break;
        case 'update':
            store.dispatch('flow/' + ConnectFlowModelingActions.EDIT_NODE, {
                data: { component },
            });
            break;
    }

    showForm.value = false;
}

function getNodeComponent(component: string) {
    switch (component) {
        case NodeType.TIME_VALIDATION:
            return ClockIcon;
        case NodeType.OPEN_EDGE:
            return PlusCircleIcon;
        case NodeType.PLAY_AUDIO:
            return PlayIcon;
        case NodeType.CLIENT_INFO:
            return QuestionMarkCircleIcon;
        case NodeType.TRANSFER_EXTENSION:
        case NodeType.TRANSFER_EXTERNAL:
        case NodeType.TRANSFER_QUEUE:
        case NodeType.TRANSFER_VIRTUAL_AGENT:
            return ReplyIcon;
        case NodeType.TRANSFER_SURVEY:
            return AnnotationIcon;
        case NodeType.HANG_UP:
            return PhoneMissedCallIcon;
        case NodeType.GO_TO:
            return ReceiptRefundIcon;
        case NodeType.GO_TO_CONNECT_FLOW:
            return ExternalLinkIcon;
        case NodeType.CONNECT_FLOW_CUSTOM:
            return AdjustmentsIcon;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_UiRightPanel = _resolveComponent("UiRightPanel")!

  return (_openBlock(), _createBlock(_component_UiRightPanel, {
    modelValue: showForm.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showForm).value = $event)),
    title: _ctx.$t('connectFlow.componentSelector')
  }, {
    default: _withCtx(() => [
      (rules.value !== undefined)
        ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(NodeType), (type) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `nodeButton${type}`
                }, [
                  (
                            rules.value.typesChildren.includes(type) &&
                            (type !== _unref(NodeType).CONNECT_FLOW_CUSTOM || hasConnectFlowCustomOptions.value)
                        )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        type: "button",
                        onClick: ($event: any) => (setUpNode(type)),
                        class: "flex cursor-pointer items-center rounded bg-gray-50 shadow ring-1 ring-gray-300 hover:bg-white focus:ring-2 focus:ring-opacity-50"
                      }, [
                        _createElementVNode("div", _hoisted_4, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(getNodeComponent(type)), { class: "text-secondary h-8 w-8" }))
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(`connectFlow.node.${type}.title`)), 1),
                          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t(`connectFlow.node.${type}.helpText`)), 1)
                        ])
                      ], 8, _hoisted_3))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})